import { useEffect, useRef, useState, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import { Paper } from "@material-ui/core";
import Select from 'react-select';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import MaterialTable, { MTableToolbar } from "material-table";
import axios from "axios";
import _ from "lodash";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import { Link, useNavigate } from "react-router-dom";
import authHeader from "../../services/auth-header";
import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import GetAccountingService from "../../services/accounting/addAccountingService";



function AccountingSetup() {
  const [data, setData] = useState([]);
  const tableRef = useRef();
  var contractNumber = "";
  var transactiontypes = "";
  var producttytpe = "";
  var customerName = "";
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [selectedValue2, setSelectedValue2] = useState('');
  const navigate = useNavigate();
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const INCOME_BASIS = {
    Accrual: "Accrual",
    Cash: "Cash",
  };
  const [selectedBasis, setSelectedBasis] = useState("");
  const [selectedEnabled, setSelectedEnabled] = useState("");
  const [transactionLookup, setTransactionLookup] = useState({});
  const [accountLookup, setAccountLookup] = useState({});

  const loadAccountCodes = () => {
    GetAccountingService.getaccountcode().then((response) => {
      const lookup = {};

      response.data.forEach((item) => {
        lookup[item.account_code] = item.account_code;
      });

      setAccountLookup(lookup);
    });
  };

  const transactiontype = () => {

    // Transaction Types
    GetAccountingService.getTransactiontype().then((response) => {
      const lookup = {};

      response.data.forEach((item) => {
        lookup[item.transaction_type] = item.transaction_type;
      });

      setTransactionLookup(lookup);
    });

    // Account Codes
    GetAccountingService.getaccountcode().then((response) => {
      const lookup = {};

      response.data.forEach((item) => {
        lookup[item.account_code] = item.account_code;
      });

      setAccountLookup(lookup);
    });

  };


  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}accounting/transactiontypes/filter/?transaction_types=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };



  const handleDeleteRule = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this rule?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {

            axios
              .delete(API + `accounting/accountsetup-delete/${id}/`, {
                headers: authHeader(),
              })
              .then(() => {

                toast.success("Rule deleted successfully", {
                  position: "top-right",
                  autoClose: 1000,
                });

                tableRef.current && tableRef.current.onQueryChange();
              })
              .catch(() => {
                toast.error("Failed to delete rule", {
                  position: "top-right",
                  autoClose: 1000,
                });
              });

          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  const tableIcons = {
    Edit: forwardRef((props, ref) => (
      <img
        ref={ref}
        {...props}
        src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
        alt="edit"
        style={{ cursor: "pointer", width: 18 }}
      />
    )),
  };

  const handelSearch = () => {
    tableRef.current.onQueryChange();
  };
  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2('');
    setSelectedBasis('');
    setSelectedEnabled('');
    tableRef.current.onQueryChange();
  };
  const ENABLED = {
    Y: "Yes",
    N: "No",
  };
  const DR_CR = {
    D: "Debit",
    C: "Credit",
  };
  const [tablename, setTablename] = useState([])
  const [columnname, setColumnname] = useState([])
  const [table_name, setTableName] = useState([])
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');


  const canEditControllerFields =
    permissionsArray.includes("can_view_controller");

  const AmountObjectView = () => {
    let url = API + "accounting/amountobjectview/";
    axios.get(url, { headers: authHeader() })
      .then((response) => {
        const dataMap = {};
        response.data.forEach((item) => {
          dataMap[item.column_name] = item.user_column_name;
        });
        setColumnname(dataMap)
        const uniqueTableNames = new Set();
        const transformedData = response.data.reduce((accumulator, item) => {
          if (!uniqueTableNames.has(item.table_name)) {
            uniqueTableNames.add(item.table_name);
            accumulator.push({ key: item.table_name, value: item.user_table_name });
          }
          return accumulator;
        }, []);
        const dataMaps = {};

        setTablename(transformedData);
        response.data.forEach((item) => {
          if (!dataMaps.hasOwnProperty(item.table_name)) {
            dataMaps[item.table_name] = item.user_table_name;
          }
          setTableName(dataMaps)
        });
      })
  }

  useEffect(() => {
    AmountObjectView();
    transactiontype();
    loadAccountCodes();

  }, []);

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10;

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };
      if (selectedValue2 && selectedValue) {

        transactiontypes = selectedValue.transaction_type;
        producttytpe = selectedValue2
      }
      else if (selectedValue) {
        transactiontypes = selectedValue.transaction_type;
      }
      else if (selectedValue2) {
        producttytpe = selectedValue2

      }
      let url = API + "accounting/accountsetup/?";
      url += "per_page=" + query.pageSize;
      url += "&page=" + (query.page + 1);
      url += `&transaction_types=${transactiontypes !== "" ? transactiontypes : ""
        }`;
      url += `&product_type=${producttytpe !== "" ? producttytpe : ""
        }`;
      url += `&basis=${selectedBasis !== "" ? selectedBasis : ""}`;
      url += `&enabled=${selectedEnabled !== "" ? selectedEnabled : ""}`;

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  return (
    <div className="container-fluid py-4 pt-2">
      <div className="row py-2 mt-2">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex">
                <div>
                  {/* <h5 className="mb-0 tc">{t("Accounting Rules")}</h5> */}
                  {/* <h5 className="mb-0">{t("Rules")}</h5> */}
                </div>

                {/* <div className="ms-auto my-auto mt-lg-0 mt-4">
                  <div className="ms-auto my-auto">
                    <div
                    > */}
                {/* <span
                        onClick={() => setState({ isPaneOpen: true })}
                        style={{
                          color: "#b4b7c5",
                          paddingRight: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/static/images/ic-filter.svg"
                          }
                          alt="Filter Icon"
                        />
                      </span> */}
                {/* {

                        permissionss && permissionsArray.includes('add_accountsetup') === true ?
                          <Link
                            className="navbar-brand m-0"
                            to="/addaccountingsetup"
                          >
                            <button
                              className="add-party add btn btn-primary  mb-0"
                              id="add-task"
                            >
                              +&nbsp; {t("Add")}
                            </button>
                          </Link> : ""
                      } */}
                {/* </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="body">
              <div className="p-0">
                <MaterialTable
                  tableRef={tableRef}
                  icons={tableIcons}
                  title="Rules"
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  columns={[
                    {
                      title: `${t("Transaction Type")}`,
                      field: "transaction_type",
                      editable: canEditControllerFields ? "always" : "never",
                      lookup: transactionLookup,

                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Type")}</div>
                          <div>{rowData.transaction_type}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Transaction Sub Type")}`,
                      field: "transaction_sub_type",
                      editable: canEditControllerFields ? "always" : "never",

                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Sub Type")}</div>
                          <div>{rowData.transaction_sub_type}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Product Type")}`,
                      field: "product_type",
                      editable: canEditControllerFields ? "always" : "never",
                      lookup: {
                        Lease: "Lease",
                        Loan: "Loan",
                        Rental: "Rental"
                      },

                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Product Type")}</div>
                          <div>{rowData.product_type}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Account Name")}`,
                      field: "account_code",
                      // field: "account_code",
                      editable: canEditControllerFields ? "always" : "never",
                      lookup: accountLookup,

                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Account Name")}</div>
                          <div> {rowData.account_code ? rowData.account_code : ""}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Amount Object")}`,
                      field: "amount_object",
                      editable: canEditControllerFields ? "always" : "never",

                      lookup: table_name,
                      render: (rowData) => <>
                        <div className="d-xl-none tc d-md-none d-lg-none"
                        >{t("Amount Object")}</div>
                        <div>
                          {table_name[rowData.amount_object]}
                        </div></>
                      ,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Amount Column")}`,
                      field: "amount_column",
                      editable: canEditControllerFields ? "always" : "never",

                      lookup: columnname ? columnname : {},
                      render: (rowData) =>
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none"
                          >{t("Amount Column")}</div>
                          <div>{columnname[rowData.amount_column]}
                          </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("DR/CR")}`,
                      field: "de_cr_code",
                      editable: canEditControllerFields ? "always" : "never",

                      lookup: DR_CR,
                      render: (rowData) => <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("DR/CR")}</div>
                        <div> {DR_CR[rowData.de_cr_code]}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Basis")}`,
                      field: "basis",
                      lookup: INCOME_BASIS,
                      editable: "onUpdate",
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Enabled")}`,
                      field: "enabled",
                      lookup: ENABLED,
                      render: (rowData) => <>
                        <div className="d-xl-none tc d-md-none d-lg-none">{t("Enabled")}</div>
                        <div> {ENABLED[rowData.enabled]}
                        </div></>,
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  actions={[
                    {
                      icon: () => (
                        <img
                          src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                          alt="edit"
                          style={{ cursor: "pointer", width: 18 }}
                        />
                      ),
                      tooltip: "Edit Rule",
                      onClick: (event, rowData) => {
                        tableRef.current.dataManager.changeRowEditing(rowData, "update");
                        tableRef.current.setState({
                          ...tableRef.current.dataManager.getRenderState(),
                          showAddRow: false
                        });
                      }
                    },

                    ...(permissionss && permissionsArray.includes('can_view_controller')
                      ? [{
                        icon: () => (
                          <img
                            src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                            alt="delete"
                            style={{ cursor: "pointer", width: 18 }}
                          />
                        ),
                        tooltip: "Delete Rule",
                        onClick: (event, rowData) => {
                          handleDeleteRule(rowData.id);
                        }
                      }]
                      : [])
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      const { orderBy, orderDirection } = query;
                      // if (selectedValue2 && selectedValue) {
                      //   contractNumber = selectedValue2.contract_number;
                      //   customerName = selectedValue.id;
                      // } else if (selectedValue2) {
                      //   contractNumber = selectedValue2.contract_number;
                      if (selectedValue2 && selectedValue) {

                        transactiontypes = selectedValue.transaction_type;
                        producttytpe = selectedValue2
                      }
                      else if (selectedValue) {
                        transactiontypes = selectedValue.transaction_type;
                      }
                      else if (selectedValue2) {
                        producttytpe = selectedValue2

                      }
                      let url = API + "accounting/accountsetup/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      url += `&transaction_types=${transactiontypes !== "" ? transactiontypes : ""
                        }`;
                      url += `&product_type=${producttytpe !== "" ? producttytpe : ""
                        }`;
                      url += `&basis=${selectedBasis !== "" ? selectedBasis : ""}`;
                      url += `&enabled=${selectedEnabled !== "" ? selectedEnabled : ""}`;
                      if (orderBy) {
                        url += `&orderBy=${orderBy.field}`;
                        url += `&orderDirection=${orderDirection}`;
                      }
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                  result.data,
                                  [query.orderBy.field],
                                  [query.orderDirection]
                                )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  editable={{
                    isEditHidden: () => true,
                    onRowUpdate: permissionss && permissionsArray.includes('add_accountsetup') === true ? (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        const updatedStatusData = {
                          transaction_type: newData.transaction_type,
                          transaction_sub_type: newData.transaction_sub_type,
                          product_type: newData.product_type,
                          account_code: newData.account_code,   // correct mapping
                          enabled: newData.enabled,
                          amount_object: newData.amount_object,
                          amount_column: newData.amount_column,
                          de_cr_code: newData.de_cr_code,
                          basis: newData.basis
                        };
                        axios
                          .post(
                            API + `accounting/accountsetup-edit/${oldData.id}/`,
                            updatedStatusData,
                            { headers: authHeader() }
                          )
                          .then(() => {

                            toast.success("Rule updated successfully", {
                              position: "top-right",
                              autoClose: 1000,
                            });

                            tableRef.current && tableRef.current.onQueryChange(); // reload table
                            resolve();

                          })
                          .catch((error) => {
                            console.error("Error updating status:", error);
                            reject();
                          });
                      }) : "",
                  }}
                  components={{
                    // Container: (props) => (
                    //   <div id="Payment">
                    //     <Paper {...props} />
                    //   </div>
                    // ),

                    Toolbar: (props) => (
                      <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                        <MTableToolbar {...props} />

                        <span
                          onClick={() => setState({ isPaneOpen: true })}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-filter.svg"
                            }
                            alt="Filter Icon"
                            style={{ width: "18px" }}
                          />
                        </span>

                        {
                          permissionss && permissionsArray.includes('can_view_controller') === true ?

                            <Link className="navbar-brand m-0" to="/addaccountingsetup">
                              <button
                                className="add-party add btn btn-primary  mb-0"
                                id="add-task"
                              >
                                +&nbsp; {t("Add Rule")}
                              </button>
                            </Link>
                            : ""
                        }
                      </div>
                    ),





                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
                      color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    actionsColumnIndex: -1,
                    showEditIcon: false,
                    showTextRowsSelected: false,
                    sorting: true,
                    search: false,
                    toolbar: true,
                    paging: true,
                    showEditIcon: false,
                    pageSize: 10, // make initial page size
                    emptyRowsWhenPaging: false, // To avoid of having empty rows
                    exportAllData: true,
                    exportButton: true,
                    exportFileName: "Rules",
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                    exportCsv: async (columns, data) => {
                      try {
                        const allData = await fetchAllDataForExport(); // Fetch all data
                        const title = "Rules Report";
                        const currentDate = new Date().toLocaleDateString();
                        const csvContentWithInfo = `${title}\n ${selectedValue !== null ? `Fiter By Transaction Type : ${selectedValue.transaction_type}\n` : ''} ${selectedValue2 !== '' ? `Fiter By Product Type : ${selectedValue2}\n` : ''} Date: ${currentDate}\n \n\n`;
                        const csvColumns = columns.map(columnDef => columnDef.title);

                        const csvData = allData.map(rowData => {
                          const rowDataArray = columns.map(columnDef => {
                            return rowData[columnDef.field] || '';
                          });
                          return rowDataArray;
                        });

                        const csvRows = [csvColumns, ...csvData];

                        const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = 'Rules.csv';
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      } catch (error) {
                        console.error("Error exporting CSV:", error);
                      }
                    },

                    exportPdf: async (columns, data) => {
                      const allData = await fetchAllDataForExport(); // Fetch all data
                      if (allData.length === 0) {
                        console.error("No data found for PDF export");
                        return;
                      }
                      const doc = new jsPDF();
                      doc.setFont("helvetica", "bold");
                      doc.setFontSize(16);

                      const title = "Rules Report";
                      doc.text(title, 14, 10);

                      doc.setFontSize(12);
                      doc.setFont("helvetica", "normal");
                      const currentDate = new Date().toLocaleDateString();
                      doc.text(`Date: ${currentDate}`, 14, 15);

                      if (selectedValue !== null || selectedValue2 !== '') {
                        const selectedVal = selectedValue?.transaction_type;
                        const selectedVal2 = selectedValue2;
                        if (selectedValue !== null & selectedValue2 !== '') {
                          doc.text(`Filter By Transaction Type and Product Type : ${selectedVal === 'undefined' ? "" : selectedVal} and ${selectedVal2 === 'undefined' ? "" : selectedVal2}`, 14, 20);
                        }
                        else if (selectedValue !== null) {
                          doc.text(`Filter By Transaction Type : ${selectedVal === 'undefined' ? "" : selectedVal} `, 14, 20);
                        }
                        else if (selectedValue2 !== '') {

                          doc.text(`Filter By  Product Type : ${selectedVal2 === 'undefined' ? "" : selectedVal2}`, 14, 20);
                        }
                      }
                      const space = 22; // Adjust the space value as needed
                      const tableStartY = 5 + space;
                      const columnTitles = columns.map(columnDef => columnDef.title);
                      const pdfData = allData.map(rowData =>
                        columns.map(columnDef => {
                          return rowData[columnDef.field];
                        })
                      );
                      const tableData = [columnTitles, ...pdfData];

                      // doc.autoTable({
                      autoTable(doc, {
                        head: [tableData[0]], // Column headers
                        body: tableData.slice(1), // Data excluding headers
                        startY: tableStartY,
                      });

                      doc.save(`Rules.pdf`);
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <SlidingPane
          className="some-custom-class"
          overlayClassName="some-custom-overlay-class"
          isOpen={state1.isPaneOpen}
          title="Filter By"
          subtitle=""
          onRequestClose={() => {
            setState({ isPaneOpen: false });
          }}
        >
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Transaction Type")}
              </label>
              <div className="col-lg-12">
                <Select
                  value={selectedValue}
                  filterOption={false}
                  options={options2}
                  isClearable
                  onInputChange={handelInputChange}
                  getOptionLabel={(options) => options.transaction_type}
                  getOptionValue={(options) => options.transaction_type}
                  isLoading={isLoading2}
                  placeholder={t("Search for Transactiontype(%for All)")}
                  onMenuScrollToBottom={handleMenuScrollToBottomName}
                  onChange={handelChange}
                />
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Product Type")}
              </label>
              <div className="col-lg-12">
                <select value={selectedValue2} className="form-control " onChange={(e) => setSelectedValue2(e.target.value)}>
                  <option value="">Select product type</option>
                  <option value="Lease">Lease</option>
                  <option value="Loan">Loan</option>
                  <option value="Rental">Rental</option>
                </select>
                {/* <Select
                            value={selectedValue2}
                            filterOption={false}
                            options={options}
                            isClearable
                            onInputChange={handleInputChangeData}
                            getOptionLabel={(options) => options.contract_number}
                            getOptionValue={(options) => options.contract_number}
                            isLoading={isLoading}
                            placeholder={t("Search for Contract(%for All)")}
                            onMenuScrollToBottom={handleMenuScrollToBottom}
                            onChange={handelChange2}
                          /> */}
              </div>
              <input type="hidden" id="contract_status" value="" />
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Basis")}
              </label>
              <div className="col-lg-12">
                <select
                  value={selectedBasis}
                  className="form-control"
                  onChange={(e) => setSelectedBasis(e.target.value)}
                >
                  <option value="">Select Basis</option>
                  <option value="Accrual">Accrual</option>
                  <option value="Cash">Cash</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <label className="col-lg-12 col-form-label">
                {t("Enabled")}
              </label>
              <div className="col-lg-12">
                <select
                  value={selectedEnabled}
                  className="form-control"
                  onChange={(e) => setSelectedEnabled(e.target.value)}
                >
                  <option value="">Select Enabled</option>
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="form-group row">
              <div
                className="col-lg-12 text-left"
                style={{ marginTop: "30px" }}
              >
                <button
                  type="button"
                  className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                  onClick={handleClear}
                >
                  {t("Reset")}
                </button>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="filter add btn btn-primary btn-m ms-auto mb-0"
                  onClick={handelSearch}
                >
                  {t("Apply")}
                </button>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </SlidingPane>
      </div>
    </div >
  );
}

export default AccountingSetup;
